import jsonSchemaSchema from "ajv/lib/refs/json-schema-draft-07.json";
import { setSchemaDraft07 } from "./json-schema.js";
setSchemaDraft07(jsonSchemaSchema);
